export enum EngineeringSystemsTypes {
  Default = 'default',
  Filter = 'filter',
  Heating = 'heating',
  PowerSupply = 'powerSupply',
  Sewerage = 'sewerage',
  Ventilation = 'ventilation',
}
